/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Form, Select, Input, Announcement, notification, Button } from '@block/plug';
import M, { upload } from '@block/utils';
import { SuccessFile } from '@src/types/self';
import PhotoCrop from '../../components/PhotoCrop';
import Url from './url';
import { doAction } from '../../utils';
import defaultPhoto from '../../../imgs/formal-example.png';
import './index.scss';

const tipList = [
  '本人真实照片，白底半身照，面部无遮挡、免冠',
  '2寸（照片长宽比16:11，不低于560*385像素）',
  '大小300K以上，不超过15M，格式为 jpg/png',
];

const isMrnAble =
  window.location.href.includes('fromMRN') || (window.NX?.getUA().isNEIXIN && window.NX.compareVersion('5.16.0') <= 0);

interface Props {
  ref: any;
  location: any;
}

interface State {
  data: any;
  photo: any;
}
class BasicInfo extends React.Component<Props, State> {
  formRef = React.createRef<Form>();

  photoRef = React.createRef<PhotoCrop>();

  constructor(props: Props) {
    super(props);
    this.dataChanged = false;

    this.state = {
      data: null,
      photo: {},
    };
  }

  dataChanged: boolean;

  async componentDidMount() {
    const data = await doAction(Url.getInfo, {}, null);
    this.setState({ data });
    this.formRef.current?.setAllFieldsValue(data);
    const pathname = (window.location.hash.slice(1) && window.location.hash.slice(1)) || '/';
    const misId = M.getCookie('_lxsdk_cuid'); // 灵犀PC端的用户设备标识，用来区分UV的
    const time = new Date().getTime(); // 获取页面时间戳
    const valLab = { custom: { pathname, misId, time } };
    // eslint-disable-next-line no-undef
    window.LXAnalytics('pageView', valLab, null, 'c_ead_29djhaw2');
  }

  handleFieldValueChange = (code: string, value: DefaultAny) => {
    const ref = this.formRef.current;
    // if (code === 'pinYinXingId') {
    //   ref?.setFieldsValue({
    //     pinYinXingName: value,
    //   });
    // }
    // if (code === 'pinYinMingId') {
    //   ref?.setFieldsValue({
    //     pinYinMingName: value,
    //   });
    // }
    // 英文名称
    if (code === 'englishName') {
      ref?.setFieldsValue({
        englishName: value,
      });
    }
    // if (code === 'photoUrl') {
    //   const { fileUrl, photoFileId } = value;
    //   this.formRef.current?.setFieldsValue({
    //     photoUrl: fileUrl,
    //     photoFileId,
    //   });
    // }
    this.dataChanged = true;
  };

  handleFetchSelectData = async (type: string, params: DefaultAny) => {
    let url = null;
    if (type === 'lastName') url = Url.getPinYinXing; // 姓
    if (type === 'name') url = Url.getPinYinMing; // 名
    const data = await doAction(url, params, null);
    return data.pageList;
  };

  // 保存
  handleSave = async () => {
    const ref = this.formRef.current;
    const finalData = await this.handleFetchFinalData();
    if (ref?.validateFields?.()) {
      const data = await doAction(Url.save, finalData);
      return data === undefined ? false : data;
    }
    return false;
  };

  // 获取最终组织数据
  // eslint-disable-next-line consistent-return
  handleFetchFinalData = async () => {
    const ref = this.formRef.current;
    const data = ref.getFieldsValueIncludeHide();
    const photoInfoBlob = await this.photoRef.current.uploadImage();
    if (photoInfoBlob) {
      const photoFile = this.handleBlobToFile(photoInfoBlob);
      try {
        const res: SuccessFile = await upload(Url.workCardUpload, photoFile);
        const { fileId, fileUrl } = res;
        ref?.setFieldsValue?.({
          photoUrl: fileUrl,
          photoFileId: fileId,
        });
        this.dataChanged = false;
        return { ...data, photoUrl: fileUrl, photoFileId: fileId };
      } catch (e) {
        notification.error({
          message: e.message,
          duration: 5000,
        });
      }
    } else {
      return data;
    }
  };

  handleBlobToFile = (blob) => {
    const { photo } = this.state;
    const file = new window.File([blob], photo.name, { type: photo.type });
    return file;
  };

  handleSuccess = (type: string, file: SuccessFile) => {
    const { fileId, fileUrl } = file;
    const ref = this.formRef.current;
    ref?.setFieldsValue?.({
      photoUrl: fileUrl,
      photoFileId: fileId,
    });
    this.dataChanged = true;
    fileId && ref.clearValidateStatus(['photoUrl']);
  };

  handleChangePhotoUrl = (file) => {
    // this.dataChanged = true;
    const ref = this.formRef.current;
    file && ref.clearValidateStatus(['photoUrl']);
    this.setState({ photo: file });
  };

  handleMRNImgCommit = async (event, btn) => {
    btn.loading(true);
    const photoInfoBlob = await this.photoRef.current.uploadImage();
    if (photoInfoBlob) {
      const photoFile = this.handleBlobToFile(photoInfoBlob);
      try {
        const res = await upload(Url.workCardUpload, photoFile, {
          headers: { 'access-token': window.location.href.split('&token=')[1] },
        });
        const { fileId, fileUrl } = res as SuccessFile;
        if (window.location.href.includes('version')) {
          window.postMessage(JSON.stringify({ fileUrl, fileId }));
        } else {
          window.ReactNativeWebView.postMessage(JSON.stringify({ fileUrl, fileId }));
        }
      } catch (e) {
        if (window.location.href.includes('version')) {
          window.postMessage(JSON.stringify(e));
        } else {
          window.ReactNativeWebView.postMessage(JSON.stringify(e));
        }
      } finally {
        btn.loading(false);
      }
    } else {
      if (window.location.href.includes('version')) {
        window.postMessage(JSON.stringify({ name: 'Error', message: '请上传照片' }));
      } else {
        window.ReactNativeWebView.postMessage(JSON.stringify({ name: 'Error', message: '请上传照片' }));
      }
      btn.loading(false);
    }
  };

  pinYinValidator = (rule, value, callback) => {
    const { dictValue } = value;
    if (/^[a-z\s]+$/.test(dictValue)) {
      callback();
    } else {
      callback('拼音姓及拼音名仅允许出现小写英文字母，请修改');
    }
  };

  // 渲染图片提示
  renderTip = () => (
    <div className="basic__tip">
      <div className="basic__content">
        <div className="basic__title">照片将用于工卡制作，务必按要求提交</div>
        <ul>
          {tipList.map((v) => (
            <li key={v}>{v}</li>
          ))}
        </ul>
      </div>
      <img className="basic__photo" src={defaultPhoto} alt="示例图片" />
    </div>
  );

  render() {
    const { ref, location } = this.props;
    const { data } = this.state;
    return (
      <div className="basic" ref={ref}>
        <Form
          className="basic__form"
          ref={this.formRef}
          labelWidth="100px"
          onFieldValueChange={this.handleFieldValueChange}
        >
          <Form.Item formItemKey="photoUrl" label="白底证件照：" required message="请上传工卡照片">
            <div className="basic__wrapper">
              {this.renderTip()}
              <PhotoCrop
                toFormItem
                ref={this.photoRef}
                isMrnAble={location.search && isMrnAble}
                onChange={this.handleChangePhotoUrl}
              />
            </div>
          </Form.Item>
          <Form.Item>
            <div className="basic__announcement">
              <Announcement title="请核查姓/名与法定证件是否相符，若发现不符，请联系您的招聘负责人修改。" showIcon type="warning" />
            </div>
          </Form.Item>
          <Form.Item formItemKey="chXing" label="姓：" required>
            <Input toFormItem disabled />
          </Form.Item>
          <Form.Item formItemKey="chMing" label="名：" required>
            <Input toFormItem disabled />
          </Form.Item>
          <Form.Item>
            <div className="basic__pinYinXing_announcement">
              <Announcement
                title="请准确填写您的拼音姓、拼音名，公司帐号会按照拼音姓名进行生成，请仔细核对。"
                showIcon
                type="warning"
              />
            </div>
          </Form.Item>
          <Form.Item
            formItemKey="pinYinXingId"
            labelInValue={false}
            formItemLabel="pinYinXingName"
            label="拼音姓："
            required
            message="不能为空"
            rules={[{ required: true, message: '不能为空' }, { validator: this.pinYinValidator }]}
          >
            <Select
              toFormItem
              keyField="dictIndex"
              labelField="dictValue"
              filterable
              onFetchData={(filter = '') => {
                const { chXing } = data;
                return this.handleFetchSelectData('lastName', {
                  filter,
                  parentIndex: chXing,
                });
              }}
              placeholder="请选择多音字"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.basic__form'),
              }}
            />
          </Form.Item>
          <Form.Item
            formItemKey="pinYinMingId"
            labelInValue={false}
            formItemLabel="pinYinMingName"
            label="拼音名："
            required
            message="不能为空"
            rules={[{ required: true, message: '不能为空' }, { validator: this.pinYinValidator }]}
          >
            <Select
              toFormItem
              keyField="dictIndex"
              labelField="dictValue"
              filterable
              onFetchData={(filter = '') => {
                const { chMing } = data;
                return this.handleFetchSelectData('name', {
                  filter,
                  parentIndex: chMing,
                });
              }}
              placeholder="请选择多音字"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.basic__form'),
              }}
            />
          </Form.Item>
          <Form.Item hide formItemKey="englishName" label="英文名：">
            <Input toFormItem maxLength={50} />
          </Form.Item>
          <Form.Item formItemKey="positionName" label="职位：">
            <span toFormItem />
          </Form.Item>
          <Form.Item formItemKey="entryDateStr" label="入职日期：">
            <span toFormItem />
          </Form.Item>
          <Form.Item formItemKey="deptName" label="部门：">
            <span toFormItem />
          </Form.Item>
        </Form>
        {location.search && isMrnAble && (
          <Button className="mrn-cardimg-commit" type="primary" onClick={this.handleMRNImgCommit}>
            提交
          </Button>
        )}
      </div>
    );
  }
}

export default BasicInfo;
